import _ from 'lodash';

const TEMPLATE_POINTER_FIELDS = [
  'editor_templates_categories_default_pointer',
  'editor_templates_categories_pointer',
  'editor_project_types_default_pointer',
  'editor_project_types_pointer',
  'editor_project_formats_default_pointer',
  'editor_project_formats_pointer',
];

const PAGE_FIELDS_TO_REMOVE = [
  'id',
  'objectId',
  'createdAt',
  'updatedAt',
  'org_pointer',
  'preview',
  'hash',
  'ACL',
  '__typename',
  'className',
  '__type',
  'editor_templates_default_pointer',
  'editor_templates_pointer',
];

export const getPointerId = (pointer) => {
  if (typeof pointer === 'string') {
    return pointer.trim() || undefined;
  }

  if (!pointer || typeof pointer !== 'object') {
    return undefined;
  }

  return (
    getPointerId(pointer.objectId) ||
    getPointerId(pointer.id) ||
    getPointerId(pointer.link)
  );
};

export const extractTemplatePages = (template) => {
  const pagesField = template?.isGlobal
    ? 'editor_templates_default_pages'
    : 'editor_templates_pages';
  const pages = template?.[pagesField];

  let pageItems;

  if (Array.isArray(pages)) {
    pageItems = pages;
  } else if (Array.isArray(pages?.edges)) {
    pageItems = pages.edges.map((edge) => edge?.node);
  } else {
    pageItems = [];
  }

  if (pageItems.length === 0 || pageItems.some((page) => !page)) {
    throw new Error('Template pages not found');
  }

  return _.cloneDeep(pageItems);
};

export const buildDuplicateTemplateData = (
  templateToDuplicate,
  isGlobalTarget
) => {
  const data = {
    name: isGlobalTarget ? '' : 'Modello Personalizzato',
    isGlobal: isGlobalTarget,
  };

  TEMPLATE_POINTER_FIELDS.forEach((field) => {
    const pointerId = getPointerId(templateToDuplicate?.[field]);

    if (pointerId) {
      data[field] = pointerId;
    }
  });

  if (templateToDuplicate?.metadata) {
    data.metadata = _.cloneDeep(templateToDuplicate.metadata);
  }

  return data;
};

export const prepareDuplicatePageData = (page, isGlobalTarget) => {
  if (!page || typeof page !== 'object') {
    throw new Error('Invalid template page');
  }

  const data = _.cloneDeep(page);

  PAGE_FIELDS_TO_REMOVE.forEach((field) => {
    delete data[field];
  });

  Object.keys(data).forEach((field) => {
    if (!field.endsWith('_pointer')) return;

    const pointerId = getPointerId(data[field]);

    if (pointerId) {
      data[field] = pointerId;
    } else {
      delete data[field];
    }
  });

  if (isGlobalTarget) {
    data.isGlobal = true;
  } else {
    delete data.isGlobal;
  }

  return data;
};

export const attachDuplicatePageToTemplate = (
  page,
  newTemplate,
  isGlobalTarget
) => {
  const templateId = getPointerId(newTemplate);

  if (!templateId) {
    throw new Error('Duplicated template id not found');
  }

  const data = _.cloneDeep(page);

  delete data.editor_templates_default_pointer;
  delete data.editor_templates_pointer;

  if (isGlobalTarget) {
    data.editor_templates_default_pointer = templateId;
    data.isGlobal = true;
  } else {
    data.editor_templates_pointer = templateId;
    delete data.isGlobal;
  }

  return data;
};
